import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = {
  id: "bottom-navigation",
  class: "block fixed inset-x-0 bottom-0 z-10 bg-white shadow pb-6 pt-1"
}
const _hoisted_3 = {
  id: "tabs",
  class: "flex justify-between"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "block text-xs" }, "ホーム", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "block text-xs" }, "検索", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "block text-xs" }, "優待管理", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "block text-xs" }, "お気に入り", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "block text-xs" }, "マイページ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomeIcon = _resolveComponent("HomeIcon")!
  const _component_MagnifyingGlassIcon = _resolveComponent("MagnifyingGlassIcon")!
  const _component_ShoppingCartIcon = _resolveComponent("ShoppingCartIcon")!
  const _component_HeartIcon = _resolveComponent("HeartIcon")!
  const _component_UserIcon = _resolveComponent("UserIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["w-full justify-center inline-block text-center pt-2 pb-1", 
            _ctx.currentMenuItemId === _ctx.MenuItemIds.Home
              ? 'text-green-lightShow'
              : 'text-black'
          ]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBottomBarNavigation(_ctx.MenuItemIds.Home)))
        }, [
          _createVNode(_component_HomeIcon, { class: "block h-6 w-6 m-auto text-sm" }),
          _hoisted_4
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["w-full justify-center inline-block text-center pt-2 pb-1", 
            _ctx.currentMenuItemId === _ctx.MenuItemIds.Browse
              ? 'text-green-lightShow'
              : 'text-black'
          ]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goBottomBarNavigation(_ctx.MenuItemIds.Browse)))
        }, [
          _createVNode(_component_MagnifyingGlassIcon, { class: "block h-6 w-6 m-auto text-sm" }),
          _hoisted_5
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["w-full justify-center inline-block text-center pt-2 pb-1", 
            _ctx.currentMenuItemId === _ctx.MenuItemIds.Reserve
              ? 'text-green-lightShow'
              : 'text-black'
          ]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goBottomBarNavigation(_ctx.MenuItemIds.Reserve)))
        }, [
          _createVNode(_component_ShoppingCartIcon, { class: "block h-6 w-6 m-auto text-sm" }),
          _hoisted_6
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["w-full justify-center inline-block text-center pt-2 pb-1", 
            _ctx.currentMenuItemId === _ctx.MenuItemIds.Favorite
              ? 'text-green-lightShow'
              : 'text-black'
          ]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goBottomBarNavigation(_ctx.MenuItemIds.Favorite)))
        }, [
          _createVNode(_component_HeartIcon, { class: "block h-6 w-6 m-auto text-sm" }),
          _hoisted_7
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["w-full justify-center inline-block text-center pt-2 pb-1", 
            _ctx.currentMenuItemId === _ctx.MenuItemIds.Profile
              ? 'text-green-lightShow'
              : 'text-black'
          ]),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goBottomBarNavigation(_ctx.MenuItemIds.Profile)))
        }, [
          _createVNode(_component_UserIcon, { class: "block h-6 w-6 m-auto text-sm" }),
          _hoisted_8
        ], 2)
      ])
    ])
  ]))
}